/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';
export { WalletSavedCardsSection } from './WalletSavedCardsSection';

export {
  WALLET_SAVED_CARDS_TEST_IDS,
  WALLET_SAVED_CARDS_TRACKING_KEYS,
  SAVED_CARDS_MODAL_IDS,
} from './WalletSavedCardsSection.constants';

const WalletSavedCardsSection = dynamic(() =>
  import('./WalletSavedCardsSection').then(mod => mod.WalletSavedCardsSection)
);

export const WalletSavedCardsSectionConfig = {
  emptyLabel: 'walletsavedcardssection',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/walletsavedcardssection`,
};

export const WalletSavedCardsSectionEditable = (props: any) => (
  <EditableComponent config={WalletSavedCardsSectionConfig} {...props}>
    <WalletSavedCardsSection {...props} />
  </EditableComponent>
);

export type {
  WalletSavedCardsSectionProps,
  WalletSavedCardsSectionModel,
  SavedCard,
} from './WalletSavedCardsSection.types';
